<template>
  <div class="hm-balance">
    <span v-if="Number(balance) === 0" class="hm-balance__paid">
      <PaidIcon />
      Paid
    </span>
    <span
      v-else
      :class="{
        'hm-balance__value--neg': Number(balance) < 0,
        'hm-balance__value--pos': Number(balance) > 0
      }"
      class="hm-balance__value"
    >
      {{ formatMoney(balance) }}
    </span>
  </div>
</template>

<script>
import PaidIcon from '@/views/hotel-management/reservations/detail/icons/PaidIcon.vue'

export default {
  name: 'HMBalance',
  props: {
    balance: {
      type: [Number, String],
      required: true,
    }
  },
  components: {
    PaidIcon,
  },
  methods: {
    formatMoney(n) {
      const num = Number(n) || 0
      const sign = num > 0 ? '+' : ''
      return `${sign}${new Intl.NumberFormat('en-US').format(num)}$`
    },
  }
}
</script>

<style scoped>
.hm-balance {
  font-family: 'CoreSansCR', sans-serif;
  font-weight: 500;
  line-height: 1;
}

.hm-balance__paid {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 64px;
  height: 24px;
  padding: 4px 6px;
  color: #468832;
  border-radius: 20px;
  background-image: linear-gradient(180deg, #E3E8D9 0%, #DCE4CD 100%);
  font-size: 13px;
}

.hm-balance__value {
  color: #000;
  font-size: 15px;
}

.hm-balance__value--neg {
  color: #A64833;
}

.hm-balance__value--pos {
  color: #468832;
}
</style>